import {
  ADD_DYNAMIC_WORKFLOW,
  REMOVE_DYNAMIC_WORKFLOW,
  CLEAR_ALL_DYNAMIC_WORKFLOWS
} from '../mutation-type'
import { dynamicWFSchema } from 'src/schema/dynamic-workflows'
// import _ from 'lodash'

// initial state
const state = []

// mutations
const mutations = {
  [ADD_DYNAMIC_WORKFLOW] (state, workflow) {
    state.push(dynamicWFSchema(workflow))
  },

  [REMOVE_DYNAMIC_WORKFLOW] (state, index) {
    state.splice(index, 1)
  },

  [CLEAR_ALL_DYNAMIC_WORKFLOWS] (state) {
    state = []
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/dynamic-workflows.js